import { getIdentityUtils } from "../../../utils";

// The task calendar only ever
// appears embedded inside one of these role dashboards. Pick the first one
// the user's capabilities allow, falling back to the generic dashboard.
const ROLE_DASHBOARD_LINKS: { capability: string; href: string }[] = [
  { capability: "VIEW-SALES-MENU", href: "/sales_dashboard.php" },
  { capability: "VIEW-PRODUCTION-MENU", href: "/production_dashboard.php" },
  { capability: "VIEW-FINANCE-MENU", href: "/finance_dashboard.php" },
  { capability: "VIEW-MANAGEMENT-MENU", href: "/management_dashboard.php" },
];

/** Resolves the "View All Tasks" link to the user's role-appropriate dashboard page. */
export function getTasksDashboardUrl(identity: any): string {
  const { hasCapabilities } = getIdentityUtils(identity);
  const match = ROLE_DASHBOARD_LINKS.find(({ capability }) => hasCapabilities([capability]));
  return match?.href ?? "/dashboard.php";
}
